import React from 'react';
import { applyStyles } from '../../utils/applyStyles';
import styles from './styles/EquityDisplay.module.css';
import { VisibilityExtendedToggle, VisibilityToggle } from '../../types/toggles';
import { spaceSeparatedThousands } from '../../utils/number';
import TrendIcon from '../../icons/TrendIcon';
import { useUser } from '../../utils/useUser';

interface Props {
  equityValue: number;
  styleName?: string;
  mmPath?: boolean;
  isSelected?: boolean;
}

const EquityDisplay: React.FC<Props> = ({ equityValue, styleName, mmPath, isSelected = true }) => {
  const user = useUser();

  const isComponentHidden =
    user?.AccountInfo?.AccountOptions?.InvestorHistoryTab === VisibilityExtendedToggle.Hide ||
    user?.AccountInfo?.AccountOptions?.InvestorOpenOrdersTab === VisibilityExtendedToggle.Hide;

  const isHiddenForInvMaster =
    user?.AccountInfo?.AccountOptions?.MasterHistoryTab === VisibilityToggle.Hide ||
    user?.AccountInfo?.AccountOptions?.MasterOpenOrdersTab === VisibilityToggle.Hide;

  if (isComponentHidden && !mmPath) {
    return null;
  }

  if (isHiddenForInvMaster && mmPath) {
    return null;
  }

  let color = 'var(--green)';

  if (equityValue === 0) {
    if (isSelected) {
      color = getComputedStyle(document.documentElement).getPropertyValue('--text-lighter-color').trim();
    } else {
      color = getComputedStyle(document.documentElement).getPropertyValue('--black-400').trim();
    }
  } else if (equityValue < 0) {
    color = 'var(--red)';
  }

  return (
    <span style={{ color }} className={applyStyles(['text-semibold', styles[`${styleName}`] || ''])}>
      <TrendIcon up={equityValue >= 0} color={color} />
      {spaceSeparatedThousands(equityValue)}%
    </span>
  );
};

export default EquityDisplay;
